// Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import {
  FormGroup,
  ReactiveFormsModule
} from '@angular/forms';
import { CommonModule, } from '@angular/common';

// Material
import { MatCheckboxModule } from '@angular/material/checkbox';

// Local library
import { WithdrawCheckByEmailService } from '@amwager/funding/data-access';
import { UnsubscribeObservableService,
  TranslatePipe
} from '@amwager/util';

// Third party
import { Subscription, takeUntil } from 'rxjs';


@Component({
  selector: 'feature-mat-check-by-email',
  templateUrl: './check-by-email.component.html',
  styleUrls: ['./check-by-email.component.scss'],
  imports: [
    CommonModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    TranslatePipe
  ],
  standalone: true,
  providers: [WithdrawCheckByEmailService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckByEmailComponent extends UnsubscribeObservableService implements OnInit {

  checkByEmailForm!: FormGroup;
  // convenience getter for easy access to form fields
  get formVal() { return this.checkByEmailForm?.controls }
  private subsWithdrawCheckByEmailResponse!: Subscription;

  showErrorMsg = '';
  amount!: number;
  total!: number;
  isProcessing = false;
  isAgree = false;

  fullName!: string;
  address!: string;
  location!: string;

  isOnline: boolean = true;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly checkByEmailService: WithdrawCheckByEmailService,
  ) {
    super();
  }

  ngOnInit() {
    this.checkConnectivity();

    // OLD (moved to WithdrawCheckByEmailService.buildForm):
    // this.initForm();
    this.checkByEmailForm = this.checkByEmailService.buildForm();

    this.total = this.amount;

    this.fullName = 'Loading...';
    this.address = 'Loading...';
    this.location = 'Loading...';

    // OLD (getUserAccoutAPI + success stream moved to WithdrawCheckByEmailService.loadUserAccount$):
    // this.accountFacade.getUserAccoutAPI();
    // this.accountFacade.isGetUserAccountSuccess$()
    this.checkByEmailService.loadUserAccount$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((response) => {
      if (response !== undefined) {
        // OLD (name build moved to WithdrawCheckByEmailService.userFullName):
        // this.fullName = this.sessionService.getUserFName() + ' ' + this.sessionService.getUserLast();
        this.fullName = this.checkByEmailService.userFullName();
        this.address = response.Address;
        this.location = response.TownCity + ', ' + response.State + ' ' + response.Zipcode;
      }

      this.cdRef.markForCheck();
    });

  }

  showAlertMessage(header: string, message: string): void {
    // OLD (moved to WithdrawCheckByEmailService.showAlert):
    // this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
    this.checkByEmailService.showAlert(header, message);
  }

  withdrawAmount(): void {
    this.amount = this.formVal['amount']?.value;
    this.total = this.amount;
  }

  withdraw(): void {
    if (!this.isOnline) {
      // OLD (moved to WithdrawCheckByEmailService.setOffline):
      // this.commonFacade.setIsConnectedInternet('CheckByEmailComponent:withdraw', false);
      this.checkByEmailService.setOffline('CheckByEmailComponent:withdraw');
      return;
    }

    if (this.checkByEmailForm.valid && this.amount && this.isAgree) {
      this.isProcessing = true;

      // OLD (dispatch + success stream moved to WithdrawCheckByEmailService.withdraw$):
      // this.fundingFacade.withdrawCheckByEmail('Check', this.amount);
      // this.subsWithdrawCheckByEmailResponse = this.fundingFacade.isWithdrawCheckByEmailSuccess$()
      this.subsWithdrawCheckByEmailResponse = this.checkByEmailService.withdraw$('Check', this.amount)
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response !== undefined) {
          this.showAlertMessage('Withdraw Error', response.error.Message);
          this.isProcessing = false;
          this.cdRef.markForCheck();
        }


        this.subsWithdrawCheckByEmailResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage('Successful Withdrawal', 'Check Withdrawal successful. Your request will be processed within 2 business days.');
          this.checkByEmailForm.reset();
          this.isAgree = false;
          this.isProcessing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      // OLD (moved to WithdrawCheckByEmailService.markFormGroupTouched):
      // this.fundingService.markFormGroupTouched(this.checkByEmailForm);
      this.checkByEmailService.markFormGroupTouched(this.checkByEmailForm);
    }
  }

  toggleCheckbox(): void {
    this.isAgree = !this.isAgree;
  }

  checkConnectivity(): void {
    // OLD (moved to WithdrawCheckByEmailService.checkConnectivity):
    // this.fundingService.checkConnectivity(
    //   this.environment,
    //   'CheckByEmailComponent:checkConnectivity',
    //   (online: boolean) => this.isOnline = online
    // );
    this.checkByEmailService.checkConnectivity(
      'CheckByEmailComponent:checkConnectivity',
      (online: boolean) => this.isOnline = online
    );
  }

}
